import FItem from '.';
import { toLatin } from '@/utils/string';

export default class FItemString extends FItem {
  __value = '';

  constructor(props) {
    super(props);
    this.min = props.min || 0;
    if (props.min) {
      this.setValidatorMin(props.min);
    }
    this.max = props.max || Infinity;
    if (props.max) {
      this.setValidatorMax(props.max);
    }
  }

  set(value = '') {
    super.set(value);
  }

  setValidatorMin(num, message = 'Минимальная длина') {
    this.setValidator((value) => {
      if (value && value.length < num) {
        return Promise.reject(`${message}: ${num}`);
      }
      return Promise.resolve();
    }, false);
    return this;
  }

  setValidatorMax(num, message = 'Максимальный длина') {
    this.setValidator((value) => {
      if (value && value.length > num) {
        return Promise.reject(`${message}: ${num}`);
      }
      return Promise.resolve();
    }, false);
    return this;
  }

  setValidatorFIO(message = 'Неверный формат') {
    this.setValidator((value) => {
      if (value && !value.match(/.(.)* .(.)* .(.)*/gi)) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, false);
    return this;
  }

  setValidatorEmail(message = 'Неверный формат') {
    this.setValidator((value) => {
      if (value && !value.match(/.(.)*@.(.)*\..(.)*/gi)) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, false);
    return this;
  }

  setLat(value) {
    this.set(toLatin(value));
  }
}
